// extracted by mini-css-extract-plugin
module.exports = {"settingsContainer":"style_settingsContainer__3j8-x","aside":"style_aside__3G8Yo","entry":"style_entry__2-ki_"};